import React, { useEffect, useState } from "react"
import { Button, Container, Form, Image, Message, Transition } from "semantic-ui-react"
import { endpoint } from "../../api/http"
import { Images } from '../../assets/assets'
import Panel from "../../components/shared/Panel"
import PasswordInput from "../../components/shared/PasswordInput"
import { useLoader } from "../../components/shared/utils"
import { UpdatePassword } from "../../api/services/organization"
//import { useTextResources } from "../../language"

const ChangePasswordPage = (props) => {
    //const text = useTextResources()
    const loader = useLoader()
    const [visible, setVisible] = useState(false)
    const [error, setError] = useState(false)
    const [success, setSuccess] = useState(false)
    const [errorText, setErrorText] = useState("")
    const [successText, setSuccessText] = useState("")
    const [currentPassword, setCurrentPassword] = useState("")
    const [newPassword, setNewPassword] = useState("")
    const [confirmPassword, setConfirmPassword] = useState("")

    // Get data passed from the MVC view
    const { userId, username } = props || {}

    useEffect(() => {
        setVisible(true)
    }, [])

    const validatePassword = (password) => {
        // Password validation rules (matching the server-side validation)
        const minLength = 8
        const hasUpperCase = /[A-Z]/.test(password)
        const hasLowerCase = /[a-z]/.test(password)
        const hasNumbers = /\d/.test(password)
        const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password)
        const containsUsername = username && password.toLowerCase().includes(username.toLowerCase())

        if (password.length < minLength) {
            return "Password must be at least 8 characters long"
        }
        if (!hasUpperCase) {
            return "Password must contain at least one uppercase letter"
        }
        if (!hasLowerCase) {
            return "Password must contain at least one lowercase letter"
        }
        if (!hasNumbers) {
            return "Password must contain at least one number"
        }
        if (!hasSpecialChar) {
            return "Password must contain at least one special character"
        }
        if (containsUsername) {
            return "Password cannot contain your username"
        }
        return null
    }

    const updatePassword = async (event) => {
        setError(false)
        setSuccess(false)
        loader(true)
        event.preventDefault()

        try {
            // Client-side validation
            if (!currentPassword) {
                setError(true)
                setErrorText("Current password is required")
                loader(false)
                return
            }

            const passwordError = validatePassword(newPassword)
            if (passwordError) {
                setError(true)
                setErrorText(passwordError)
                loader(false)
                return
            }

            if (newPassword !== confirmPassword) {
                setError(true)
                setErrorText("Passwords do not match")
                loader(false)
                return
            }

            // Send request to server using the API service
            const result = await UpdatePassword({
                UserId: userId,
                CurrentPassword: currentPassword,
                NewPassword: newPassword
            })

            loader(false)

            if (result.success) {
                setSuccess(true)
                setSuccessText(result.message)
                // Redirect after a short delay
                setTimeout(() => {
                    window.location.href = result.redirectUrl || endpoint
                }, 2000)
            } else {
                setError(true)
                setErrorText(result.message || "Failed to update password")
            }
        } catch (err) {
            loader(false)
            setError(true)
            setErrorText("An error occurred while updating your password. Please try again.")
        }
    }

    return (
        <Container textAlign="center">
            <div style={{ marginTop: 50 }}></div>
            <Transition animation="drop" duration={1000} visible={visible}>
                <Image centered size='small' src={Images.logo} />
            </Transition>
            <div style={{ width: 500, marginLeft: "auto", marginRight: "auto", marginTop: 40, textAlign: "left" }}>
                <Panel header="Change Password">
                    <Form error={error} success={success} onSubmit={updatePassword}>
                        <PasswordInput 
                            name="currentPassword" 
                            placeholder="Current Password" 
                            icon='lock' 
                            iconPosition='left'
                            value={currentPassword}
                            onChange={(e) => setCurrentPassword(e.target.value)}
                        />
                        <PasswordInput 
                            name="newPassword" 
                            placeholder="New Password" 
                            icon='key' 
                            iconPosition='left'
                            value={newPassword}
                            onChange={(e) => setNewPassword(e.target.value)}
                        />
                        <PasswordInput 
                            name="confirmPassword" 
                            placeholder="Confirm New Password" 
                            icon='key' 
                            iconPosition='left'
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                        />
                        
                        <Message info>
                            <Message.Header>Password Requirements:</Message.Header>
                            <Message.List>
                                <Message.Item>At least 8 characters long</Message.Item>
                                <Message.Item>At least one uppercase letter</Message.Item>
                                <Message.Item>At least one lowercase letter</Message.Item>
                                <Message.Item>At least one number</Message.Item>
                                <Message.Item>At least one special character (!@#$%^&*)</Message.Item>
                                <Message.Item>Cannot contain your username</Message.Item>
                            </Message.List>
                        </Message>

                        {error && (
                            <Message
                                error
                                header='Password Update Failed'
                                content={errorText}
                            />
                        )}

                        {success && (
                            <Message
                                success
                                header='Password Updated Successfully'
                                content={successText + " Redirecting..."}
                            />
                        )}

                        <Button 
                            type='submit' 
                            primary 
                            disabled={!currentPassword || !newPassword || !confirmPassword}
                        >
                            Update Password
                        </Button>
                    </Form>
                </Panel>
            </div>
        </Container>
    )
}

export default ChangePasswordPage
